import Vue from 'vue'

export const Bdc = {
    namespaced: true,
    state: () => {
        return {
            /**
             * ID da base de conhecimento selecionada.
             */
            idDatabase: null,

            /**
             * ID do space que a base de conhecimento está selecionada.
             */
            idSpace: null,

            /**
             * Categorias mostradas na lateral da página.
             */
            categorias: null,

            /**
             * Conhecimentos da categoria selecionada, paginado.
             */
            conhecimentos: null,

            /**
             * ID da categoria que está selecionada na interface. Se for null nenhuma está selecionada.
             */
            idCategoriaSelecionada: null,

            /**
             * ID do conhecimento que está selecionado.
             */
            conhecimentoSelecionado: null,

            /**
             * Registro do conhecimento selecionado, usado na edição do formulário.
             */
            registroConhecimentoSelecionado: null,

            /**
             *
             */
            search: '',

            /**
             * Qual visualização está aberta no momento. Por exemplo, estamos na lista de conhecimentos (null)
             * ou criando um novo conhecimento?
             */
            view: null,
        }
    },
    getters: {
        categoriaSelecionada: state => {
            if (!state.categorias) return null
            return state.categorias.find(c => c.id == state.idCategoriaSelecionada)
        },

        encontrarConhecimentoPorId: state => id => {
            if (!state.conhecimentos) return null
            return state.conhecimentos.data.find(c => c.id == id)
        },
    },
    mutations: {
        /**
         * Atualiza o ID da base de conhecimentos selecionada.
         */
        atualizarDatabaseSelecionada(state, { id_database, id_space }) {
            state.idDatabase = id_database
            state.idSpace = id_space
        },

        /**
         * Adiciona a categoria na lista de categorias. Geralmente usado após o usuário criar
         * uma nova categoria.
         */
        adicionarCategoria(state, categoria) {
            if (state.categorias === null) state.categorias = []
            state.categorias.push(categoria)
        },

        /**
         * Atualiza o ID da categoria selecionada.
         */
        atualizarCategoriaSelecionada(state, idCategoria) {
            state.idCategoriaSelecionada = idCategoria
        },

        /**
         * Atualiza o ID do conhecimento selecionado.
         */
        atualizarConhecimentoSelecionado(state, conhecimento) {
            state.conhecimentoSelecionado = conhecimento
        },

        /**
         * Atualiza os conhecimentos carregados.
         */
        atualizarConhecimentos(state, conhecimentosPaginados) {
            state.conhecimentos = conhecimentosPaginados
        },

        /**
         * Adiciona o conhecimento na lista de conhecimentos que estão sendo mostradas na lista.
         */
        adicionarConhecimento(state, conhecimento) {
            if (!state.conhecimentos) return
            if (!state.conhecimentos.data) return

            state.conhecimentos.data.unshift(conhecimento)
        },

        incrementarConhecimentosDaCategoria(state, id_categoria) {
            let categoria = state.categorias.find(cat => cat.id == id_categoria)
            if (categoria) categoria.conhecimentos_count = categoria.conhecimentos_count + 1
        },

        decrementarConhecimentosDaCategoria(state, id_categoria) {
            let categoria = state.categorias.find(cat => cat.id == id_categoria)
            if (categoria) categoria.conhecimentos_count = Math.max(categoria.conhecimentos_count - 1, 0)
        },

        /**
         * Atualiza o conhecimento na lista de conhecimentos que estão carregados na memória.
         */
        atualizarConhecimento(state, conhecimento) {
            if (!state.conhecimentos) return
            if (!state.conhecimentos.data) return

            state.conhecimentos.data = state.conhecimentos.data.map(c => {
                if (c.id == conhecimento.id) {
                    return conhecimento
                } else {
                    return c
                }
            })
        },

        /**
         * Atualiza o termo de pesquisa.
         */
        atualizarSearch(state, search) {
            state.search = search
        },

        /**
         * Atualizar a view da página.
         */
        atualizarView(state, view) {
            state.view = view
        },
    },
    actions: {
        /**
         * Seleciona a base de conhecimento. Geralmente executada uma única vez quando o usuário acessa a página da database.
         */
        selecionarDatabase({ state, commit, dispatch }, { id_database, id_space }) {
            if (state.idDatabase == id_database) {
                return
            }

            commit('atualizarDatabaseSelecionada', { id_database, id_space })
            dispatch('carregarCategoriasDaDatabaseSelecionada')
        },

        /**
         * Envia uma requisição HTTP para carregar as categorias da base de conhecimento selecionada.
         */
        async carregarCategoriasDaDatabaseSelecionada({ commit, state }) {
            let { data } = await axios.get('/bdc/categories?all&id_database=' + state.idDatabase)

            data.forEach(categoria => {
                commit('adicionarCategoria', categoria)
            })
        },

        /**
         * Atualiza a categoria selecionada e carrega os conhecimentos dessa categoria.
         */
        async selecionarCategoriaPeloId({ commit, state }, { id_categoria, page }) {
            if (state.idCategoriaSelecionada == id_categoria) {
                if (state.conhecimentos && state.conhecimentos.current_page == page) {
                    return
                }
            }

            commit('atualizarCategoriaSelecionada', id_categoria)
            commit('atualizarConhecimentos', null)

            let { data } = await axios.get('/bdc/questions?keyword_ids_categorias=' + id_categoria + '&page=' + page)

            commit('atualizarConhecimentos', data)
        },

        /**
         * Atualiza o conhecimento selecionado.
         */
        async selecionarConhecimentoPeloId({ commit, getters }, idConhecimento) {
            let conhecimento = getters.encontrarConhecimentoPorId(idConhecimento)
            if (conhecimento) {
                commit('atualizarConhecimentoSelecionado', conhecimento)
            } else {
                commit('atualizarConhecimentoSelecionado', { id: idConhecimento })
                let { data } = await axios.get('/bdc/questions/' + idConhecimento)
                commit('atualizarConhecimentoSelecionado', data)
            }
        },
    },
}
